import { render, staticRenderFns } from "./BlogPostItem.vue?vue&type=template&id=86212cd8&scoped=true"
import script from "./BlogPostItem.vue?vue&type=script&lang=js"
export * from "./BlogPostItem.vue?vue&type=script&lang=js"
import style0 from "./BlogPostItem.vue?vue&type=style&index=0&id=86212cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86212cd8",
  null
  
)

export default component.exports